var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('radio-button-group',{staticClass:"main__credit-card-switcher payment-provider-radio-list",attrs:{"list":_vm.list,"value":_vm.value},on:{"input":_vm.input}},[_c('CreditCardsList',{attrs:{"slot":"credit-card"},slot:"credit-card"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }